import { Translatable } from "@icc/shared/helpers";

export class BoxDepthExtension {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    /** Kod do wydruków */
    printCode: string;
    @Translatable({ model: 'Profiles' })
    /** Nazwa */
    name: string;
    /** Zdjęcie */
    img: string;
    /** Opis */
    description: string;
    /** Przypisane typy produktu */
    shutterTypesIds: number[];
    /** Waga */
    weight?: number;
    /** Pasujące skrzynki */
    blindBoxesIds?: number[];

    /** Wysokość minimalna pasujących skrzynek */
    minBlindBoxHeight?: number;
}
